<template>
    <div data-v-6ebeef4c>
        <usertop></usertop>
        <div data-v-48992eda="" class="el-col el-col-24">
            <div data-v-48992eda="" class="el-card is-never-shadow">
                <div class="el-card__body" style="padding: 16px; text-align: left;">
                    <div data-v-48992eda="" class="G-title"><span data-v-48992eda="">修改资料</span></div>
                    <div data-v-48992eda="" style="max-width: 25rem; margin: 0px auto; padding: 1rem !important;">
                        <form @submit.prevent="editform_submit" data-v-48992eda="" class="el-form el-form--label-top" :model="editform">
                            <div data-v-48992eda="" class="el-form-item"><label class="el-form-item__label">用户名</label>
                                <div class="el-form-item__content">
                                    <div data-v-48992eda="" class="el-input is-disabled"><input type="text"
                                            disabled="disabled" autocomplete="off" v-model="editform.username" class="el-input__inner"></div>
                                </div>
                            </div>
                            <div data-v-48992eda="" class="el-form-item"><label for="email"
                                    class="el-form-item__label">邮箱</label>
                                <div class="el-form-item__content">
                                    <div data-v-48992eda="" class="el-input"><input type="text" autocomplete="off" class="el-input__inner" v-model="editform.email" @keyup.enter="editform_submit"></div>
                                </div>
                            </div>
                            <div data-v-48992eda="" class="el-form-item"><label for="old_password"
                                    class="el-form-item__label">旧密码</label>
                                <div class="el-form-item__content">
                                    <div data-v-48992eda="" class="el-input el-input--suffix"><input type="password" autocomplete="off" class="el-input__inner" placeholder="修改邮箱请输入旧密码" v-model="editform.jiu_password" @keyup.enter="editform_submit"><span class="el-input__suffix"><span class="el-input__suffix-inner"></span></span>
                                    </div>
                                </div>
                            </div>
                            <div data-v-48992eda="" class="el-form-item"><label for="new_password"
                                    class="el-form-item__label">新密码</label>
                                <div class="el-form-item__content">
                                    <div data-v-48992eda="" class="el-input el-input--suffix"><input type="password" autocomplete="off" class="el-input__inner" placeholder="不修改密码无需输入" v-model="editform.new_password" @keyup.enter="editform_submit"><span class="el-input__suffix"><span class="el-input__suffix-inner"></span></span>
                                    </div>
                                </div>
                            </div>
                            <div data-v-48992eda="" class="el-form-item form-group">
                                <div class="el-form-item__content"><button data-v-48992eda="" type="button" class="el-button el-button--primary" style="width: 100%;"><span>确认修改</span></button></div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'editprofile',
    data() {
        return {

            editform:{
                username:'',
                email:'',
                jiu_password:'',
                new_password:'',
            },

        }
    },
    methods: {
        editform_submit(){

            let form = this.editform
            
            this.$http.post('/api/userinfo',{action:2,data:form}).then(res=>{

                if(res.data.code==1){
                    this.$message({
                        message: res.data.msg,
                        type: 'success',
                        onClose:()=>{
                            window.location.href='editprofile';
                        }
                    });
                }else if(res.data.code==0){
                    this.$message({
                        message: res.data.msg,
                        type: 'error',
                    });
                }
            })
        }
    },
    mounted() {

        this.$http.post('/api/userinfo',{action:1}).then(res=>{

            this.editform.username = res.data.username
            this.editform.email = res.data.email

        })

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/editprofile.vue